function isMobile() {
  const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return regex.test(navigator.userAgent);
}

// The accordion lives inside the product-info container, so a packs-dropdown
// repaint replaces it with fresh markup. Re-run init on `product-info-repainted`
// so the new headers get their click handlers (handlers are assigned via
// `onclick`, so re-running never stacks listeners).
initAccordion();
window.addEventListener('product-info-repainted', initAccordion);

function initAccordion() {
  const accContainer = document.querySelector('.info-accordion__container');
  if (!accContainer) return;

  // Manually opening the tab with class 'styled-with-slider'
  const styledWithSliderPanel = accContainer.querySelector('#styled-with-slider');
  if (styledWithSliderPanel) {
    styledWithSliderPanel.previousElementSibling.classList.add('active');
    styledWithSliderPanel.style.maxHeight = styledWithSliderPanel.scrollHeight + 'px';
  }

  const acc = accContainer.querySelectorAll('.info-accordion__header');
  // Manually opening and closing tabs
  acc.forEach((item) => {
    if (item.dataset.desktopOpen === 'true' && !isMobile()) {
      item.classList.add('active');
      if (item.nextElementSibling) {
        item.nextElementSibling.style.maxHeight = item.nextElementSibling.scrollHeight + 'px';
      }
    }

    item.onclick = function () {
      let panel = this.nextElementSibling;

      if (this.classList.contains('active')) {
        this.classList.remove('active');
        if (panel) panel.style.maxHeight = null;
      } else {
        acc.forEach((item2) => {
          if (item2) {
            item2.classList.remove('active');
            if (item2.nextElementSibling) item2.nextElementSibling.style.maxHeight = null;
          }
        });

        this.classList.add('active');
        if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    };
  });
}
